/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Group_ConnectInputs */

const en_directory_agent_readiness_group_connect = /** @type {(inputs: Directory_Agent_Readiness_Group_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect`)
};

const zh_directory_agent_readiness_group_connect = /** @type {(inputs: Directory_Agent_Readiness_Group_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接接口`)
};

/**
* | output |
* | --- |
* | "Connect" |
*
* @param {Directory_Agent_Readiness_Group_ConnectInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_group_connect = /** @type {((inputs?: Directory_Agent_Readiness_Group_ConnectInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Group_ConnectInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_group_connect(inputs)
	return zh_directory_agent_readiness_group_connect(inputs)
});
export { directory_agent_readiness_group_connect as "directory.agent_readiness.group.connect" }